import { modelHelperModule } from './model-helper';

export const customerModelModule = angular
  .module('Q.models.customer', [modelHelperModule])

  .factory('Customer', function (ModelHelper) {
    const Customer = ModelHelper.defineResource({
      name: 'Customer',
      endpoint: 'billing/customers',

      relations: {
        hasMany: {},
      },

      methods: {
        hasFeature(feature) {
          return !!(this.features && this.features[feature]);
        },
        getFeature(feature) {
          return !feature || (this.features && this.features[feature]);
        },
        subscriptionExpired(teamMember) {
          if (teamMember && teamMember.hasRole('staff')) return false;
          return !this.isActive;
        },

        isPayg() {
          return this.plan && this.plan.isPayg;
        },
        isInTrial() {
          return this.state === 'in_trial';
        },
        hasQualifiedPlan() {
          return this.isSubscribed || this.isInTrial();
        },
        usageMeasure() {
          return this.plan ? this.plan.usageMeasure : 'assessment_result';
        },
        // this version of usageMeasure doesn't know if a customer is for education or not, so always returns Candidate/Candidates.
        // if you have access to the specific team, use the method defined there instead which can distinguish between them.
        usageMeasureName(plural) {
          switch (this.usageMeasure()) {
            case 'assessment_result':
              return plural ? 'Assessment Results' : 'Assessment Result';

            case 'team_candidate':
              return plural ? 'Candidate' : 'Candidates';
          }
        },
        // combines any prepaid add-on seats with the seats included with the plan
        includedPremiumSeats() {
          let seats = this.prepaidPremiumSeats || 0;
          if (this.plan) seats += this.plan.includedPremiumSeats || 0;
          return seats;
        },
        // combines any prepaid add-on seats with the seats included with the plan
        includedRestrictedSeats() {
          let seats = this.prepaidRestrictedSeats || 0;
          if (this.plan) seats += this.plan.includedRestrictedSeats;
          return seats;
        },
        seatNextBillingAt() {
          if (this.plan) {
            if (this.plan.seatSchedule === 'base') {
              return this.remainingBillingCycles === 0
                ? null
                : this.baseNextBillingAt;
            }

            return this.usageNextBillingAt || this.baseNextBillingAt;
          }
        },
        hasAdditionalSeats() {
          return (
            this.additionalPremiumSeatsInUse > 0 ||
            this.additionalRestrictedSeatsInUse > 0
          );
        },
        outstandingBurstBalance() {
          if (this.plan) {
            return this.currentTermBurstUsage * this.plan.burstUnitPriceFloat;
          }

          return 0;
        },
        hasStandardPlan() {
          return (
            this.plan &&
            ['payg', 'starter'].indexOf(this.plan.planCategory) !== -1
          );
        },
        hasValidCreditCard() {
          return (
            this.paymentGateway === 'stripe' &&
            this.paymentMethod === 'card' &&
            this.cardStatus === 'valid'
          );
        },
        /**
         * indicates if a subscription was just updated, useful for when we may want to hold off on showing certain UI elements
         * while we wait for a full sync from the billing system.
         * @returns {*|boolean} true if subscription was changed less than 30 seconds ago
         */
        hasRecentSubscriptionChanges() {
          return (
            this.subscriptionUpdatedAt &&
            new Date() - this.subscriptionUpdatedAt < 30000
          );
        },
      },

      staticMethods: {},

      meta: {
        actionEndpoints: {
          updatePayment: { segment: 'payment', method: 'PUT', track: true },
          subscribe: { segment: 'subscription', method: 'POST', track: true },
          reactivate: {
            segment: 'subscription/reactivate',
            method: 'PUT',
            track: true,
          },
          cancelDowngrade: {
            segment: 'subscription/cancel_downgrade',
            method: 'PUT',
            track: true,
          },
          applyCoupon: {
            segment: 'subscription/coupon',
            method: 'PUT',
            track: true,
          },
          cancel: {
            segment: 'subscription/cancel',
            method: 'PUT',
            track: true,
          },
          cancelNow: { segment: 'subscription', method: 'DELETE', track: true },
          startTrial: {
            segment: 'subscription/trial',
            method: 'POST',
            track: true,
          },
          endTrial: {
            segment: 'subscription/trial',
            method: 'DELETE',
            track: true,
          },
        },
        saveExcludes: [],
      },
    });

    return Customer;
  });
